import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=32f58a05"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"
import style0 from "./PendingTasks.vue?vue&type=style&index=0&id=32f58a05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports